import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-cc2dcbf1.js';
import { m as marginPropTypes } from './spacing-7e57ffb0.js';
import { S as SvgIcon } from './SvgIcon-1308e965.js';

function IconPackage(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m11.638 6.099-.013.006-2.959 1.479v6.513l4.963-2.482a.666.666 0 0 0 .37-.596V4.918l-2.362 1.181zM4.67 2.92l-1.843.921L8 6.427l1.843-.921zm1.491-.746 5.173 2.586 1.839-.92-4.877-2.438a.664.664 0 0 0-.591 0zm-1.848-.566a.607.607 0 0 1 .114-.057L7.111.209a1.997 1.997 0 0 1 1.78 0l5.333 2.667a1.999 1.999 0 0 1 1.11 1.79v6.354c0 .759-.43 1.452-1.109 1.789l-5.333 2.667a2 2 0 0 1-1.79 0l-5.335-2.668a1.999 1.999 0 0 1-1.1-1.795V4.666c0-.759.43-1.452 1.109-1.789zm3.02 12.493V7.585L2 4.918v6.099a.665.665 0 0 0 .365.599z"
  }));
}
IconPackage.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconPackage.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconPackage as default };
